var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.roleName=='Student')?_c('PlanRenew'):_vm._e(),_c('VersionMsg'),_c('v-footer',{attrs:{"padless":"","light":"","color":_vm.getFooterColor}},[_c('v-col',{staticClass:"text-right font-weight-regular"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Copyright EDG ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }